import request from '@/utils/request'

// 获取邮箱配置列表
export function getEmailConfigs() {
  return request({
    url: '/admin/emailServerConfig/list',
    method: 'get'
  })
}

// 获取ID为1的邮箱配置
export function getEmailConfig() {
  return request({
    url: '/emailServerConfig/1',
    method: 'get'
  })
}

// 保存邮箱配置 (更新ID为1的配置)
export function saveEmailConfig(data) {
  return request({
    url: '/emailServerConfig',
    method: 'post',
    data,
    timeout: 300000 // 设置超时时间为300秒
  })
}
// 更新邮箱配置
export function updateEmailConfig(data) {
  return request({
    url: '/emailServerConfig',
    method: 'put',
    data
  })
}